import type { FC } from 'react';

import { ControlledTextField } from '@components/Form';
import type { ControlledTextFieldProps } from '@components/Form';

import type { VrsAccountFormValues } from '.';

export type VrsAccountControlledTextFieldProps = ControlledTextFieldProps<VrsAccountFormValues>;

export const VrsAccountControlledTextField: FC<VrsAccountControlledTextFieldProps> = ({
  controllerProps,
  textFieldProps,
}) => {
  return (
    <ControlledTextField
      controllerProps={{ ...controllerProps, rules: { required: 'This field is required' } }}
      textFieldProps={{ helperText: ' ', ...textFieldProps }}
    />
  );
};
